import React from 'react';

import { ToolboxComponentSchema } from 'craft/types';

import { Display } from './Display';
import { FlexChild } from './FlexChild';

interface Props {
  nodeIds: string[];
  schema: ToolboxComponentSchema['Layout'];
}

export const Layout = React.memo(({ nodeIds, schema }: Props) => {
  return (
    <>
      <FlexChild nodeIds={nodeIds} cssSelectorId={schema.cssSelectorId} />
      <Display
        nodeIds={nodeIds}
        cssSelectorId={schema.cssSelectorId}
        defaultValue={schema.defaultDisplay}
      />
    </>
  );
});

Layout.displayName = 'Layout';
